class doctorAppointmentsCardController {
	$onInit() {
		this.sponsoredDoctorActive = '';
		this.sponsoredDoctorImage = '';
		if (this.isSponsored) {
			this.sponsoredDoctorImage = 'sponsoredDoctorImage';
			this.sponsoredDoctorActive = 'sponsoredDoctorActive';
		}
	}
	returnClass(value) {
		if (value === '-') {
			return 'doctorAppointmentsCard__article__section__list__button--clear';
		}
		return '';
	}

}

export default doctorAppointmentsCardController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-appointments-card/doctor-appointments-card.controller.js